export const REQUIREMENT_GROUPS = ["all", "any_one"] as const
export type RequirementGroup = (typeof REQUIREMENT_GROUPS)[number]

export interface FormFieldOption {
  key: string
  label: string
}

/** A system-locked field, plus the earliest context it is required from —
 * "customer" names the entity's first context (every context demands it),
 * "project_type" on Lead names "estimate" (Estimate onward only). A screen
 * showing one context at a time has to filter on this before treating the
 * field as locked there. */
export interface LockedFormFieldOption extends FormFieldOption {
  from_context: string
}

export interface FormContext {
  key: string
  label: string
  inherits_from: string | null
}

export interface FormFieldRequirementGroups {
  all: string[]
  any_one: string[]
}

export interface FormFieldRequirementsPayload {
  entity: string
  contexts: FormContext[]
  fields: FormFieldOption[]
  locked_fields: LockedFormFieldOption[]
  rules: Record<string, FormFieldRequirementGroups>
}

/** The left-nav entities. Only the ones in SUPPORTED_FORM_ENTITIES have a
 * real catalog behind them today — the rest show a "not configured yet"
 * placeholder rather than fabricated data. */
export interface FormEntityNavItem {
  key: string
  label: string
}

export const FORM_ENTITY_NAV: FormEntityNavItem[] = [
  { key: "lead", label: "Lead" },
  { key: "project", label: "Project" },
  { key: "customer", label: "Customer" },
  { key: "subcontractor", label: "Subcontractor" },
  { key: "invoice", label: "Invoice" },
  { key: "change_request", label: "Change Request" },
  { key: "purchase_order", label: "Purchase Order" }
]

// Subcontractor joined on EAD-1325: the backend registers the entity with a
// `create` and an `invite` context, so the generic screen can configure it
// with no change of its own. The remaining nav entries have no catalog
// behind them and still show the "not configured yet" placeholder.
export const SUPPORTED_FORM_ENTITIES = new Set([
  "lead",
  "project",
  "subcontractor"
])
